const EYE_ICON = `
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path>
    <circle cx="12" cy="12" r="2.75"></circle>
  </svg>`;

const EYE_OFF_ICON = `
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="m3 3 18 18"></path>
    <path d="M10.6 6.15A10.7 10.7 0 0 1 12 6c6 0 9.5 6 9.5 6a16.8 16.8 0 0 1-2.1 2.75"></path>
    <path d="M6.2 6.2C3.85 7.75 2.5 12 2.5 12s3.5 6 9.5 6c1.6 0 3-.42 4.2-1.05"></path>
    <path d="M9.75 9.75A3.18 3.18 0 0 0 9.25 12 2.75 2.75 0 0 0 12 14.75c.85 0 1.6-.38 2.1-.98"></path>
  </svg>`;

function updateButton(button: HTMLButtonElement, visible: boolean): void {
  button.setAttribute('aria-pressed', String(visible));
  button.setAttribute(
    'aria-label',
    visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe',
  );
  button.setAttribute('title', visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
  button.innerHTML = visible ? EYE_OFF_ICON : EYE_ICON;
}

function decoratePasswordInput(input: HTMLInputElement): void {
  if (input.dataset.passwordVisibilityReady === 'true') return;
  input.dataset.passwordVisibilityReady = 'true';

  const control = document.createElement('span');
  control.className = 'password-control';
  control.style.marginTop = input.style.marginTop;
  control.style.marginRight = input.style.marginRight;
  control.style.marginBottom = input.style.marginBottom;
  control.style.marginLeft = input.style.marginLeft;
  input.style.margin = '0';

  const shell = document.createElement('span');
  shell.className = 'password-input-shell';
  input.parentNode?.insertBefore(control, input);
  control.appendChild(shell);
  shell.appendChild(input);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'password-visibility-toggle';
  updateButton(button, false);
  shell.appendChild(button);

  const capsLock = document.createElement('span');
  capsLock.className = 'password-caps-lock';
  capsLock.setAttribute('role', 'status');
  capsLock.setAttribute('aria-live', 'polite');
  capsLock.hidden = true;
  capsLock.textContent = 'Verr. Maj. activée';
  control.appendChild(capsLock);

  const refreshCapsLock = (event: KeyboardEvent): void => {
    capsLock.hidden = !event.getModifierState('CapsLock');
  };
  input.addEventListener('keydown', refreshCapsLock);
  input.addEventListener('keyup', refreshCapsLock);
  input.addEventListener('blur', () => {
    capsLock.hidden = true;
  });
  button.addEventListener('click', () => {
    const visible = input.type === 'password';
    input.type = visible ? 'text' : 'password';
    updateButton(button, visible);
    input.focus();
  });
}

export function enhancePasswordFields(root: ParentNode = document): void {
  if (root instanceof HTMLInputElement && root.matches('input[type="password"]')) {
    decoratePasswordInput(root);
  }
  root
    .querySelectorAll<HTMLInputElement>(
      'input[type="password"]:not([data-password-visibility-ready])',
    )
    .forEach(decoratePasswordInput);
}

export function installPasswordVisibility(): () => void {
  enhancePasswordFields(document);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) enhancePasswordFields(node);
      });
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  return () => observer.disconnect();
}
